import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import SimulatorDemo from './SimulatorDemo'
import SimulatorEditorActions from './SimulatorEditorActions'
import SimulatorElement from './SimulatorElement'
import SimulatorFormBrand from './SimulatorFormBrand'
import { STYLE_FORM_SCHEMA } from './SimulatorFormStyle'
import SimulatorFormValue from './SimulatorFormValue'
import sliderIcon from './assets/simulator.svg'

export default genElementConfig(CONFIG_ELEMENTS.simulator, {
  label: t('elements.simulator.label'),
  icon: sliderIcon,
  group: ElementGroup.interactive,
  styleFields: STYLE_FORM_SCHEMA,
  Element: SimulatorElement,
  Demo: [SimulatorDemo],
  FormValue: SimulatorFormValue,
  FormBrand: SimulatorFormBrand,
  EditorActions: SimulatorEditorActions,
})
